const React = require("react");
const T = React.PropTypes;
const UserType = require("~/types/User.js").PropType;

require("./UserInfo.less");

const UserInfo = React.createClass({
    propTypes: {
        User: UserType,
        ImpersonationTransitioning: T.bool.isRequired
    },
    render() {
        const secondLine = this.GetSecondLine();

        return (<div className="cs-UserInfo">
            <div>
                {this.props.User.DisplayName}
            </div>
            {secondLine}
        </div>);
    },
    GetSecondLine() {
        const isSuperUser = this.props.User.Roles.some((role) => {
            return role === "caudit-super-user"
                || role === "caudit-super-user-impersonating";
        });

        if (!isSuperUser) {
            return null;
        }

        if (this.props.ImpersonationTransitioning) {
            return (<div>
                Updating impersonation...
            </div>);
        }

        if (this.props.User.AlterEgo) {
            return (<div>
                <a className="cs-UserInfo__start-button" href="#survey-impersonation">
                    (Really: {this.props.User.AlterEgo.DisplayName})
                </a>
            </div>);
        }

        return (<div>
            <a className="cs-UserInfo__start-button" href="#survey-impersonation">
                Click to impersonate
            </a>
        </div>);
    }
});

module.exports = UserInfo;


// WEBPACK FOOTER //
// ./src/components/UserInfo/UserInfo.jsx